export const State8 = () => (
  <div
    style={{
      height: 8,
      width: 8,
      backgroundColor: 'var(--green-500)',
      borderRadius: '100%',
    }}
  ></div>
);
